import React from 'react';
import { PrinterIcon, ScissorsIcon, HeartHandshakeIcon } from 'lucide-react';
type PrintCutShareProps = {
  align?: 'center' | 'start';
};
const items = [{
  label: 'Imprimez',
  Icon: PrinterIcon
}, {
  label: 'Découpez',
  Icon: ScissorsIcon
}, {
  label: 'Partagez',
  Icon: HeartHandshakeIcon
}];
export function PrintCutShare({
  align = 'center'
}: PrintCutShareProps) {
  return <p className={`flex flex-wrap items-center gap-x-1.5 gap-y-2 text-navy sm:gap-x-3 ${align === 'center' ? 'justify-center' : 'justify-center lg:justify-start'}`} aria-label="Imprimez, découpez, partagez" data-id="element-221" data-mp="2057c6yduzbay">
      {items.map(({
      label,
      Icon
    }, i) => <React.Fragment key={label} data-id="element-222" data-mp="1qdkq26zzfrtf" data-mpi={i}>
          {i > 0 && <span className="text-gold" aria-hidden="true" data-id="element-223" data-mp="1lhcibeo470wa">•</span>}
          <span className="inline-flex items-center gap-1 whitespace-nowrap text-[11px] font-extrabold uppercase tracking-[0.04em] sm:gap-1.5 sm:text-base sm:tracking-[0.16em]" data-id="element-224" data-mp="2ivyghlizobih">
            <Icon className="h-4 w-4 text-coral sm:h-5 sm:w-5" aria-hidden="true" data-id="element-225" data-mp="2e35bqxnit36e" />
            {label}
          </span>
        </React.Fragment>)}
    </p>;
}